// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6a8743c4","455":"f414603c","977":"a7458867"}[chunkId] + ".chunk.js";
};